import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';

interface Contest {
    contest_id: number;
    contest_name: string;
    contest_date: string;
    entry_fee: string;
    status: 'upcoming' | 'completed';
}

const MyContest: React.FC = () => {
    const navigate = useNavigate();
    const [contests, setContests] = useState<Contest[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (!token) {
            navigate('/login');
            return;
        }

        const fetchContests = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/contestRegistration/my-contests`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const data = await res.json();
                if (data.success) {
                    setContests(data.contests);
                } else {
                    setContests([]);
                }
            } catch (err) {
                console.error(err);
                setContests([]);
            } finally {
                setLoading(false);
            }
        };

        fetchContests();
    }, [navigate]);

    const upcomingContests = contests.filter(c => c.status === 'upcoming');
    const pastContests = contests.filter(c => c.status === 'completed');

    return (
        <div className="max-w-3xl mx-auto mt-20 px-4">
            <h1 className="text-2xl font-bold mb-6 text-center text-indigo-700">My Contests</h1>

            {loading ? (
                <div className="text-center">Loading...</div>
            ) : contests.length === 0 ? (
                <div className="text-center text-gray-600">You haven't registered for any contests yet.</div>
            ) : (
                <>
                    {upcomingContests.length > 0 && (
                        <div className="mb-8">
                            <h2 className="text-xl font-semibold mb-4 text-green-600">Upcoming Contests</h2>
                            <div className="space-y-4">
                                {upcomingContests.map(contest => (
                                    <div
                                        key={contest.contest_id}
                                        className="p-4 border rounded shadow-sm bg-green-50"
                                    >
                                        <h3 className="font-semibold text-lg">{contest.contest_name}</h3>
                                        <p>
                                            Date:{" "}
                                            {new Date(contest.contest_date).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "long",
                                                year: "numeric",
                                            })}
                                        </p>
                                        <p>Entry Fee: ₹{contest.entry_fee}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {pastContests.length > 0 && (
                        <div>
                            <h2 className="text-xl font-semibold mb-4 text-gray-700">Previous Contests</h2>
                            <div className="space-y-4">
                                {pastContests.map(contest => (
                                    <div
                                        key={contest.contest_id}
                                        className="p-4 border rounded shadow-sm bg-gray-100"
                                    >
                                        <h3 className="font-semibold text-lg">{contest.contest_name}</h3>
                                        <p>
                                            Date:{" "}
                                            {new Date(contest.contest_date).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "long",
                                                year: "numeric",
                                            })}
                                        </p>
                                        <p>Entry Fee: ₹{contest.entry_fee}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default MyContest;
